import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Briefcase } from "lucide-react";

const Projects = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(3);

  const projects = [
    {
      name: "Ani-flow",
      logo: null,
      techStack: "MERN Stack, Tailwind CSS",
      description:
        "A comprehensive anime tracking web application that allows users to explore, track, and manage their favorite anime series with personalized watchlists and recommendations.",
      demoLink: "https://ani-flow.vercel.app/",
      repoLink: "https://github.com/AniFlow/ani-flow",
    },
    {
      name: "Cavoya",
      logo: "/Assets/cavoya-logo.png",
      techStack: "MERN Stack, Tailwind CSS",
      description:
        "A modern eCommerce web application for premium clothes, offering seamless product browsing, secure checkout, order management, and a smooth shopping experience.",
      demoLink: "https://cavoya.in/",
      repoLink: "https://github.com/your-username/cavoya",
    },
    {
      name: "Health Brewery",
      logo: "/Assets/healthbrewery-logo.png",
      techStack: "MERN Stack, Tailwind CSS",
      description:
        "A personalized health and nutrition platform that delivers tailored, evidence-based nutrition plans focused on sustainability, lifestyle alignment, and 1:1 expert guidance to help users achieve real, long-term health results.",
      demoLink: "https://healthbrewery.in/",
      repoLink: "https://github.com/your-username/health-brewery",
    },
    {
      name: "Wick & Stitch",
      logo: "/Assets/wick-and-stitch.png",
      techStack: "Next Js, Tailwind CSS",
      description:
        "A modern eCommerce web application for Handcrafted Candles & Handmade Crochet, offering seamless product browsing, secure checkout, order management, and a smooth shopping experience.",
      demoLink: "https://wick-and-stitch.vercel.app/",
      repoLink: "https://github.com/your-username/cavoya",
    },
    // {
    //   name: "Parking Management System",
    //   techStack: "React, Node.js, MongoDB, Express.js",
    //   description:
    //     "Designed a user-friendly dashboard for managing parking slots with real-time tracking and payment integration.",
    //   demoLink: "#",
    //   repoLink: "#",
    // },
    // {
    //   name: "Busi-Nessterr",
    //   techStack: "PHP, MYSQL, HTML, CSS, JavaScript",
    //   description:
    //     "It provides a facility to Business/Startups to keep their idead and Investors can invest in any particular business by bidding on it.",
    //   demoLink: "#",
    //   repoLink: "#",
    // },
    {
      name: "Freelance & Upwork Projects",
      logo: null, // Will use default briefcase icon
      techStack:
        "React Js, Vue Js, HTML, CSS, JavaScript, Node Js, MongoDB, Express Js, Tailwind Css",
      description:
        "Worked on various freelance projects, focusing on responsive design and performance optimization. Developed custom websites, optimized UI/UX, and integrated APIs for various clients.",
      // demoLink: "#",
      repoLink: "#",
    },
  ];

  // Update items to show based on screen size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsToShow(1); // Mobile
      } else if (window.innerWidth < 1024) {
        setItemsToShow(2); // Tablet
      } else {
        setItemsToShow(3); // Desktop
      }
    };

    handleResize(); // Set initial value
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getVisibleProjects = () => {
    const visibleProjects = [];
    for (let i = 0; i < itemsToShow; i++) {
      const index = (currentIndex + i) % projects.length;
      visibleProjects.push(projects[index]);
    }
    return visibleProjects;
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % projects.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + projects.length) % projects.length);
  };

  const showNavigation = projects.length > 3;

  return (
    <div className="py-12 px-6 max-w-7xl mx-auto">
      <h2 className="text-4xl font-bold text-[#e2e8f0] pb-6 text-center relative orbitron">
        Projects / Work
        <span className="absolute bottom-4 left-1/2 transform -translate-x-1/2 w-20 h-1 bg-gradient-to-r from-transparent via-[#94a3b8] to-transparent"></span>
      </h2>

      <div className="relative">
        {/* Navigation Buttons - Only show if more than 3 projects */}
        {showNavigation && (
          <>
            <button
              onClick={handlePrev}
              className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-[#5e7daf] hover:bg-[#232d3b] text-[#e2e8f0] p-2 rounded-full shadow-lg transition-colors duration-300"
              style={{ marginLeft: "-20px" }}
            >
              <ChevronLeft size={24} />
            </button>

            <button
              onClick={handleNext}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-[#5e7daf] hover:bg-[#232d3b] text-[#e2e8f0] p-2 rounded-full shadow-lg transition-colors duration-300"
              style={{ marginRight: "-20px" }}
            >
              <ChevronRight size={24} />
            </button>
          </>
        )}

        {/* Projects Container */}
        <div className="overflow-hidden">
          <div
            className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-transform duration-300 ${!showNavigation ? "justify-items-center" : ""
              }`}
          >
            {(showNavigation ? getVisibleProjects() : projects).map(
              (project, index) => (
                <div
                  key={showNavigation ? `${currentIndex}-${index}` : index}
                  className="bg-[#1e293b] p-6 rounded-lg shadow-lg hover:scale-105 transition-transform duration-300"
                >
                  <div className="flex items-center gap-3 mb-2">
                    {project.logo ? (
                      <img
                        src={project.logo}
                        alt={`${project.name} logo`}
                        className="w-10 h-10 object-contain rounded-md"
                      />
                    ) : (
                      <div className="w-10 h-10 flex items-center justify-center bg-[#334155] rounded-md">
                        <Briefcase className="w-6 h-6 text-[#94a3b8]" />
                      </div>
                    )}
                    <h3 className="text-2xl font-bold text-[#e2e8f0] philosopher-6">
                      {project.name}
                    </h3>
                  </div>
                  <p className="text-sm text-[#94a3b8] mt-2 philosopher-5">
                    {project.techStack}
                  </p>
                  <p className="text-[#e2e8f0] mt-4 philosopher-6">
                    {project.description}
                  </p>
                  <div className="flex justify-between mt-4">
                    <a
                      href={project.demoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#4993f5] underline hover:text-white philosopher-6 italic"
                    >
                      Link
                    </a>
                  </div>
                </div>
              ),
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
